import 'iconify-icon'
import { setCustomIconLoader, loadIcon } from 'iconify-icon'

setCustomIconLoader(async (name) => {
  const data = await loadIcon(`ci:${name}`)

  return data
    ? {
        ...data,
        body: data.body.replaceAll('stroke-width="2"', 'stroke-width="1.5"'),
      }
    : null
}, 'ci-thin')
